import { atom } from "recoil";

const clickedChildZoneAtom = atom({
  key: "clickedChildZoneState",
  default: false,
});

export default clickedChildZoneAtom;
